/**
 * DetailEventContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled detail event container.
 */

const DetailEventContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  max-width: ${1020 * Screen.widthRatio}px;
  position: absolute;
  top: ${76 * Screen.widthRatio}px;
`;

export default DetailEventContainer;
